import { IConfigsType } from '../../types'

const roundupConfig: IConfigsType = {
  timoney_bk: {
    '/:brand/corporate_roundup': {
      variables: ['corporateGroup'],
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'yesterday',
          'trailing_7_days',
          'custom',
        ],
        defaultType: 'period',
      },
      title: {
        type: 'title',
        title: 'Round Up',
      },
      downloadCsv: {
        type: 'download-csv',
        api: 'timoneyRoundup',
        fileName: 'getexpo-roundup',
        message: 'Download as CSV',
        fields: [
          'groupInfo',
          {
            key: 'roundupSales',
            title: '$ of Round Ups',
          },
          {
            key: 'roundupCheckPercent',
            title: '% of Transactions',
          },
        ],
      },

      roundupTable: {
        type: 'table-v2',
        api: 'roundup',
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: 'roundupSales',
            title: '$ of Round Ups',
            width: '150px',
            align: 'center',
            sortable: true,
            decimal: 2,
          },
          {
            key: 'roundupCheckPercent',
            title: '% of Transactions',
            width: '150px',
            align: 'center',
            sortable: true,
            decimal: 1,
          },
        ],
      },

      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'corporate-round-up',
        sendStoreId: false,
      },
    },
  },
}

export default roundupConfig
